const API_KEY = process.env.REACT_APP_API_KEY;
const API_URL = 'https://fortniteapi.io/v2/shop?lang=ru&date=2022-01-12';

export { API_KEY, API_URL };